const RoundUpMixin = {
  methods: {
    roundUpNumber(num) {
      const numOfDigits = num.toString().length;
      if (numOfDigits < 2) {
        return 10;
      } else if (numOfDigits === 2) {
        return Math.ceil(num / 10) * 10;
      }
      return Math.ceil(num / (10 ** (numOfDigits - 2))) * (10 ** (numOfDigits - 2));
    },
    isNumberRound(num) {
      return /^0*$/.test(num);
    },
  },
};

export default RoundUpMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/roundUp.js